export const FETCH_NEWS = 'FETCH_NEWS';
export const SET_NEWS = 'SET_NEWS';
export const START_LOADING_NEWS = 'START_LOADING_NEWS';
export const END_LOADING_NEWS = 'END_LOADING_NEWS';
